<!--
  SECUI OTP 체크 팝업

  @since: 2021-03-03
  @author: mk.ko
-->

<template>
  <layout-popup ref="secuiOtpPopup"
                :isOpen.sync="isOpen"
                :titleName="getTitle"
                :confirmEvt="onConfirm"
                :cancelEvt="onCancel"
                :footerBtn="['confirm', 'cancel']"
                :content-css="{minWidth: '350px', minHeight: '177px'}"
                @hide="onHide"
  >
    <div>
      <div class="content-group">
        <div class="contents-row">

          <div class="portlet">

            <div class="contents-row">

              <table class="bs-table table-bordered-none">

                <colgroup>
                  <col width="100px"/>
                  <col width="auto"/>
                </colgroup>

                <tbody>

                <tr>
                  <td class="td-head">
                      SECUI OTP <span class="textR">*</span>
                    </td>
                  <td>
                    <div class="inline-group">
                      <q-input v-model="otpKey"
                               ref="otpKey"
                               type="text"
                               name="otpKey"
                               v-validate="`required|isValidNaturalNumbers`"
                               :error="errors.has('otp.otpKey')"
                               data-vv-scope="otp"
                               maxlength="8"
                               @keydown.enter="onConfirm"
                               class="bs bs-q-input bs-q-input-default"
                               style="width:100%;"
                      >
                        <tool-tip maxLength="8" />
                      </q-input>
                    </div>
                  </td>
                </tr>

                </tbody>

              </table>

            </div>

          </div>
        </div>
      </div>

    </div>
  </layout-popup>
</template>

<script>
  import LayoutModalPopUp from '~/components/popUp/LayoutModalPopUp'

  export default {
    name: 'SecuiOtpPopup',
    props: {
      externalAuth: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'layout-popup': LayoutModalPopUp
    },
    data () {
      return {
        isOpen: false,
        otpKey: '',
        params: void 0,
        callback: void 0
      }
    },
    created () {},
    computed: {
      getTitle () {
        return this.$t('sm.tools_snmp_userAuth') // 사용자 인증
      }
    },
    methods: {
      initData () {
        this.validatorClear()

        this.otpKey = ''
        this.params = void 0
        this.callback = void 0
      },
      async show ({ callback, params }) {
        if (typeof this.$refs.secuiOtpPopup !== 'undefined' && !this.isOpen) {
          this.callback = callback
          this.params = params

          await this.$refs.secuiOtpPopup.show()

          this.$nextTick(() => {
            this.otpKey = ''
            this.$refs.otpKey.focus()
          })
        }
      },
      hide () {
        if (typeof this.$refs.secuiOtpPopup !== 'undefined' && this.isOpen) {
          this.$refs.secuiOtpPopup.hide()
        }
      },
      onHide () {
        this.initData()
      },
      async onConfirm () {
        try {
          let result = await this.validateMixins('otp')
          if (!result) {
            return
          }
          if (typeof this.callback === 'function') {
            if (_.isEmpty(this.params)) {
              this.callback(this.otpKey)
            } else {
              if (_.get(this.params, ['length'])) {
                this.callback(...this.params, this.otpKey)
              } else {
                this.callback({
                  ...this.params,
                  otpKey: this.otpKey
                })
              }
            }
          }
        } catch (e) {
          this.$log('[Secui OTP Popup GUI Error (onConfirm)]', e)
        }
      },
      onCancel () {}
    },
    watch: {}
  }
</script>

<style scoped>
</style>
